import { render } from "./ContentImageUpload.vue?vue&type=template&id=526654dd"
import script from "./ContentImageUpload.vue?vue&type=script&lang=js"
export * from "./ContentImageUpload.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__